import React from 'react';  
import './index.css';
import { SwipeAction, List,Badge,WhiteSpace,Button,Modal ,Toast} from 'antd-mobile';
import userRequest, {
     userApi
 } from 'common/request';  

import FileUploader  from '../upload';
import {
  connect
} from 'react-redux';
import {
  actionCreators
} from 'labroomExperStore';
const alert = Modal.alert;
class SwipeList extends React.Component{
  deleteList(index,name){
    alert('是否删除?',  name , [
              { text: '取消', onPress: () => {} },
              { text: '确定', onPress: () => {this.deleteReport(index)} },
            ])
  }
  changeReport(index,name){
    alert(  '是否设为主要文件并提交?', name , [
              { text: '取消', onPress: () => {} },
              { text: '确定', onPress: () => {this.mainReport(index)} },
            ])
  }
  mainReport(index){ 
    const { recordAll}=this.props; 
    let newRecord = this.props.recordAll.toJS()
    let mainList = newRecord.splice(index,1);
    newRecord.unshift(mainList[0])
    this.props.changeRecord(newRecord) 
  }
  deleteReport(index){
    const { recordAll}=this.props; 
    let newRecord = this.props.recordAll.toJS()
    let deleteList = newRecord.splice(index,1); 
    this.props.changeRecord(newRecord) 
  }
  render(){
    const { recordAll}=this.props;
    
    return(
        <List>
         
          {
          recordAll && recordAll.size!=0?
          recordAll.map((item,index)=>{
            return (
           <SwipeAction 
            key={index} 
            style={{ backgroundColor: 'gray' }}
            autoClose
            right={[
              {
                text: '取消',
                onPress: () => console.log('cancel'),
                style: { backgroundColor: '#ddd', color: 'white' },
              },
              {
                text: '删除',
                onPress: () => { this.deleteList(index, item.getIn(['resource_data','name']) )  },
                style: { backgroundColor: '#F4333C', color: 'white' },
              },
            ]}
             
          >
            <List.Item
              arrow="horizontal"
              onClick={e => { this.changeReport(index, item.getIn(['resource_data','name']) )}}
              className="special-badge" 
            >{index===0?
              <Badge  text={'主'}/>
              :
              <Badge />
            }
            {item.getIn(['resource_data','name'])}
            </List.Item>
          </SwipeAction>
          )
          })
         
         :null
        }
        </List>
      )
  }
}
 
 

class ReportList extends React.Component{
  changeRecord(newRecord){
    const {  user_id,user_name,course_id, sub_id ,addReport,changeRecordAll,buttonDisabled }=this.props;
    
     if(buttonDisabled){
       Toast.fail('对不起不能提交!!!', 2);
     }else{
      changeRecordAll(newRecord)
       let attach = newRecord.slice(1) 
       let  result = {
              report:newRecord[0],
              attach 
            }
     
      addReport(result,user_id,user_name,course_id,sub_id)
     }
    
 
  }
  render(){
    const {buttonDisabled,recordAll,user_id,user_name,course_id, sub_id,recordContent}=this.props;
    
    return (
      <div className="report-item text-center">
        <p className="report-title">我的报告</p>
        <SwipeList recordAll={recordAll} changeRecord = {(data)=>this.changeRecord(data)}/>
        <WhiteSpace />
        {
          buttonDisabled?
          <Button inline disabled className="uploadBtn">上传</Button>
          :<FileUploader  
             user_id={user_id}
             user_name={user_name}
             course_id={course_id}
             sub_id={sub_id} 
             recordContent={recordContent}
             recordAll={recordAll}
             changeRecordAll={(data)=>this.changeRecord(data)}  /> 
        }
         {
            buttonDisabled?
            <p className="warnText">{this.props.tips}</p>
            :null
         } 
        <WhiteSpace />
      </div>
      )
  }
}
 


const mapState = (state) => ({
  
  user_id: state.getIn(['home','userinfo', 'user_id']), 
  user_name: state.getIn(['home','userinfo', 'user_name']), 
  attachmentList: state.getIn(['labroomexper', 'attachmentList']),
  grade_tpl_content: state.getIn(['labroomexper', 'grade_tpl_content']),
  recordContent: state.getIn(['labroomexper', 'recordContent']),
  sub_id: state.getIn(['labroomexper', 'subjectInfo','id']),
  course_id: state.getIn(['labroomexper', 'subjectInfo','course_id']),
  recordAll: state.getIn(['labroomexper', 'recordAll']),
    
   
})
 
const mapDispatch = (dispatch) => ({
  getSubjectInfo(course_id,sub_id){
    dispatch(actionCreators.getSubjectInfo(course_id,sub_id))
  },
  getMySubRecord(user_id, sub_id){
    dispatch(actionCreators.getMySubRecord(user_id, sub_id))
  },
  changeRecordAll(data){
    dispatch(actionCreators.changeRecordAll(data))
  },
  addReport(res,user_id,user_name,course_id,sub_id){
    dispatch(actionCreators.addReport(res,user_id,user_name,course_id,sub_id))
  },
 
})

 

export default connect(mapState, mapDispatch)(ReportList);
